module.exports = __webpack_public_path__ + "static/img/third16.2d482247.png";